import React from "react";

const baseClasses =
  "inline-flex items-center justify-center gap-3 rounded-[10px] font-semibold transition disabled:cursor-not-allowed disabled:opacity-70";

const variantClasses = {
  primary:
    "h-14 w-full bg-gradient-to-r from-[#020817] via-[#06132b] to-[#0b1530] text-[16px] text-white shadow-[0_10px_30px_rgba(2,8,23,0.35)] hover:scale-[1.01]",
  teal:
    "h-12 rounded-full bg-[#006666] px-8 text-[15px] text-white shadow-[0_6px_20px_rgba(0,102,102,0.35)] hover:scale-[1.01] hover:bg-[#005858]",
  ghost:
    "w-full text-center text-[14px] font-medium text-[#4b5563] hover:text-black",
  text: "text-[14px] font-medium text-[#4b5563] hover:text-black",
};

const ArrowIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12H19M19 12L13 6M19 12L13 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Button = ({
  children,
  className = "",
  icon,
  showArrow = false,
  type = "button",
  variant = "primary",
  ...props
}) => {
  const resolvedIcon = showArrow ? <ArrowIcon /> : icon;

  return (
    <button
      type={type}
      className={`${baseClasses} ${variantClasses[variant] || variantClasses.primary} ${className}`.trim()}
      {...props}
    >
      <span>{children}</span>
      {resolvedIcon}
    </button>
  );
};

export default Button;
